import React from 'react';
import QuestionCard from '@/components/staffer/Grading/QuestionCards/QuestionCard';
import CardSkeleton from '@/components/staffer/Grading/QuestionCards/CardSkeleton';
import CardListSkeleton from '@/components/staffer/Grading/CardListSkeleton';
import StudentAnswerCard from '@/components/staffer/Grading/StudentAnswerCard';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import useIsQuestionTransitioning from '@/components/staffer/Grading/useIsQuestionTransitioning';
import { applyGradeByQuestionFilters } from '@/components/staffer/Grading/utils';
import AISuggestionBanner from '@/components/staffer/Grading/AISuggestion/AISuggestionBanner';

const StudentResultsLabel = () => (
  <div className="tw-font-bold tw-text-lg tw-pb-4">
    Student Results
  </div>
);

const Divider = () => (
  <hr className="tw-mx-[-20px] tw-text-med-grey" />
);

const QuestionResultsBody = () => {
  const isQuestionTransitioning = useIsQuestionTransitioning();
  const {
    assignment, classroom, isTeacher, questionAnswers, questionId,
  } = useGradingStore();
  // `questionAnswers == null` indicates a classroom-nav-driven reset from TopRowFilters.tsx —
  // treat it the same as a question-nav transition and skeleton the body.
  const isTransitioning = isQuestionTransitioning || questionAnswers == null;

  if (isTransitioning) {
    return (
      <>
        <CardSkeleton />
        <Divider />
        <StudentResultsLabel />
        <CardListSkeleton />
      </>
    );
  }

  // AIDEV-NOTE: Pre-existing pattern carried over from QuestionGrading.tsx — filters are read via
  // `getState()` rather than subscribed, so filter-only changes do not re-render this component.
  // Intentionally preserved to avoid changing legacy grade-by-question filter behavior; do NOT
  // "fix" by moving `filters` into the `useGradingStore()` destructure above without regression-
  // testing the filter UX end-to-end.
  const { filters } = useGradingStore.getState();
  const { questionsFilter, statusFilter } = filters;
  const question = assignment.questions.find(q => q.id === questionId);
  const { students } = classroom;
  const questionAnswersForCurrentQuestion = (questionAnswers || [])
    .filter(qa => qa.question_id.toString() === questionId.toString());
  const filteredStudents = applyGradeByQuestionFilters({
    questionAnswers: questionAnswersForCurrentQuestion,
    questionsFilter,
    statusFilter,
    students,
  });

  return (
    <>
      {isTeacher && <AISuggestionBanner questionAnswers={questionAnswersForCurrentQuestion} unit="students" />}
      <QuestionCard question={question} />
      <Divider />
      <StudentResultsLabel />
      {filteredStudents.map((student) => {
        const questionAnswer = questionAnswersForCurrentQuestion.find(qa => qa.student_id === student.id);

        return (
          <div key={`${student.id}-${question.id}`}>
            <StudentAnswerCard
              question={question}
              questionAnswer={questionAnswer}
              student={student}
            />
          </div>
        );
      })}
    </>
  );
};

export default QuestionResultsBody;
